import { apiRequest } from "./apiClient";

export function getRoles() {
  return apiRequest("/api/roles");
}
